import { defineStore } from 'pinia';
import { approvalStatusToText } from '@/ui/dictionary';
import { ApprovalStatus } from '@/entities/approvals/constants';
import { FilterEntry } from '@/entities/filter/model';

interface State {
  approvalStatuses: Array<FilterEntry & { originalTitle?: string }>;
}

export const useApprovalStatusesStore = defineStore('approvalStatuses', {
  state: (): State => ({
    approvalStatuses: [],
  }),
  actions: {
    add(status: FilterEntry) {
      this.approvalStatuses.push({
        id: status.id,
        title: approvalStatusToText(status.title as ApprovalStatus),
        originalTitle: status.title,
      });
    },
    addAll(statuses: Array<FilterEntry>) {
      this.approvalStatuses.push(
        ...statuses.map(status => ({
          id: status.id,
          title: approvalStatusToText(status.title as ApprovalStatus),
          originalTitle: status.title,
        })),
      );
    },
    find(id: number) {
      return this.approvalStatuses.find(item => item.id === id);
    },
  },
});
